module.exports = {
  VALUE_CHANGE_MODE: {
    FIXED_VALUE: 'VALOR_FIXADO',
    MODIFIABLE: 'MODIFICAVEL'
  },
  DISCOUNT_MODES: {
    FIXED_VALUE_UNTIL_THE_DATES_INFORMED: 'FIXADO_ATE_DATAS_INFORMADAS',
    PERCENTAGE_DATE_REPORTED: 'PERCENTUAL_ATE_DATA_INFORMADA',
    AMOUNT_PER_CALENDAR_DAY_ADVANCE: 'VALOR_POR_DIA_ANTECIPADO',
    AMOUNT_ADVANCE_BUSINESS_DAY: 'VALOR_POR_DIA_UTIL_ANTECIPADO',
    PERCENTAGE_ADVANCE_CURRENT_DAY: 'PERCENTUAL_POR_DIA_ANTECIPADO',
    PERCENTAGE_ADVANCE_BUSINESS_DAY: 'PERCENTUAL_POR_DIA_UTIL_ANTECIPADO'
  },
  ABATEMENT_MODES: {
    FIXED_VALUE: 'VALOR_FIXADO',
    PERCENT: 'PERCENTUAL'
  },
  FINE_MODES: {
    FIXED_VALUE: 'VALOR_FIXADO',
    PERCENT: 'PERCENTUAL'
  },
  INTEREST_MODES: {
    VALUE_CALENDAR_DAYS: 'VALOR_POR_DIA',
    PERCENTAGE_PER_DAY_CALENDAR_DAYS: 'PERCENTUAL_POR_DIA',
    PERCENTAGE_PER_MONTH_CALENDAR_DAYS: 'PERCENTUAL_POR_MES',
    PERCENTAGE_PER_YEAR_CALENDAR_DAYS: 'PERCENTUAL_POR_ANO',
    VALUE_WORKING_DAYS: 'VALOR_POR_DIA_UTIL',
    PERCENTAGE_PER_DAY_WORKING_DAYS: 'PERCENTUAL_POR_DIA_UTIL',
    PERCENTAGE_PER_MONTH_WORKING_DAYS: 'PERCENTUAL_POR_MES_DIAS_UTEIS',
    PERCENTAGE_PER_YEAR_WORKING_DAYS: 'PERCENTUAL_POR_ANO_DIAS_UTEIS'
  }
};
